import { lazy } from 'react';
import Home from '../Home';
import DashboardPage from '../pages/Dashboard';
import MicroTestPage from '../pages/MicroTestPage';

// Lazy load micro-template
const TemplatePage = lazy(() => import('microTemplate/App'));

// Lazy load micro-administration
const AdministrationPage = lazy(() => import('microAdministration/App'));
const RolesPage = lazy(() => import('microAdministration/RolesPage'));
const CompaniesPage = lazy(() => import('microAdministration/CompaniesPage'));
const OrganizationUnitsPage = lazy(() => import('microAdministration/OrganizationUnitsPage'));
const EditionsPage = lazy(() => import('microAdministration/EditionsPage'));
const AuditLogsPage = lazy(() => import('microAdministration/AuditLogsPage'));

export const componentRegistry = {
  DashboardPage,
  Tenant: CompaniesPage,
  Home,
  MicroTestPage,
  TemplatePage,
  AdministrationPage,
  Organization: OrganizationUnitsPage,
  Roles: RolesPage,
  Companies: CompaniesPage,
  Edition: EditionsPage,
  AuditLogs: AuditLogsPage,
};
